<template>
  <div class="loading" v-if="isloading">
    <div class="rect"></div>
    <div class="rect"></div>
    <div class="rect"></div>
    <div class="rect"></div>
    <div class="rect"></div>
    <div class="rect"></div>
    <div class="rect"></div>
    <div class="rect"></div>
    <div class="rect"></div>
    <div class="rect"></div>
  </div>
</template>
<script>
  export default {
    data: function () {
      return {
        text: '',
        isloading: false,
        timer: null
      }
    },
    methods: {
      show (text, duration) {
        this.text = text || '加载中'
        this.isloading = true
        if (this.timer) {
          clearInterval(this.timer)
        }
        this.timer = setTimeout(() => {
          this.isloading = false
        }, 15000)
      },
      hide () {
        this.isloading = false
      }
    }
  }
</script>
<style>
.vm-loading .rect{
  width: 8px;
  height: 36px;
  background-color: @primary-color;
  float: left;
  margin: 3px;
  animation: animate 1s infinite;
}

.vm-loading .rect:nth-child(2){
  animation-delay: 0.1s
}
.vm-loading .rect:nth-child(3){
  animation-delay: 0.2s
}
.vm-loading .rect:nth-child(4){
  animation-delay: 0.3s
}
.vm-loading .rect:nth-child(5){
  animation-delay: 0.4s
}
.vm-loading .rect:nth-child(6){
  animation-delay: 0.5s
}
.vm-loading .rect:nth-child(7){
  animation-delay: 0.6s
}
.vm-loading .rect:nth-child(8){
  animation-delay: 0.7s
}
.vm-loading .rect:nth-child(9){
  animation-delay: 0.8s
}
.vm-loading .rect:nth-child(10){
  animation-delay: 0.9s
}
@keyframes animate{
  50%{
    transform: scaleY(0)
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Loading.vue